import { parseInstantSafe, normalizeTimezone } from "./time";

export function formatAvailabilityDate(
  value: string | null | undefined,
  timeZone?: string | null,
): string | null {
  if (!value) return null;
  const parsed = parseInstantSafe(value);
  if (parsed) {
    const tz = normalizeTimezone(timeZone);
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: tz,
    }).format(parsed);
  }
  const text = String(value).trim();
  const datePart = text.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(datePart) ? datePart : text || null;
}
